import React, { useState } from 'react';
import PageWrapper from '@components/common/layout/PageWrapper';
import useTranslate from '@hooks/useTranslate';
import { ListPage } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { getData, setData } from '@utils/localStorage';
import { Tabs } from 'antd';

import DigibesRequestTab from './DigibesRequestTab';
import PiRequestTab from './PiRequestTab';

const ACTIVE_TAB_KEY = 'activeDeviceRequestTab';
const TAB_PI = 'pi';
const TAB_DIGIBES = 'digibes';

const DeviceRequestListPage = () => {
    const translate = useTranslate();
    const [activeTab, setActiveTab] = useState(getData(ACTIVE_TAB_KEY) || TAB_DIGIBES);

    const tabItems = [
        {
            key: TAB_DIGIBES,
            label: 'Digibes request',
            children: <DigibesRequestTab isActive={activeTab === TAB_DIGIBES} />,
        },
        {
            key: TAB_PI,
            label: 'Pi request',
            children: <PiRequestTab isActive={activeTab === TAB_PI} />,
        },
    ];

    return (
        <PageWrapper routes={[{ breadcrumbName: translate.formatMessage(commonMessage.deviceRequest) }]}>
            <ListPage
                baseTable={
                    <Tabs
                        type="card"
                        activeKey={activeTab}
                        onChange={(key) => {
                            setActiveTab(key);
                            setData(ACTIVE_TAB_KEY, key);
                        }}
                        items={tabItems}
                    />
                }
            />
        </PageWrapper>
    );
};

export default DeviceRequestListPage;
